import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { EditIcon } from 'src/assets/svg';
import { useCreatorAvatarEditor } from 'src/view/hooks/useCreatorAvatarEditor';

export const CreatorAvatarInput = ({
    editor,
    disabled,
}: {
    editor: ReturnType<typeof useCreatorAvatarEditor>;
    disabled: boolean;
}) => {
    const inputId = useId();
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center gap-3 mb-4">
            <img
                src={editor.preview}
                alt={t('profile.picture.label')}
                className="w-36 h-36 rounded-full object-cover"
            />
            {!disabled && (
                <>
                    <input
                        id={inputId}
                        className="sr-only"
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                        aria-label={t('profile.picture.change')}
                        onChange={editor.onChange}
                    />
                    <label
                        htmlFor={inputId}
                        className="flex items-center gap-2 cursor-pointer"
                    >
                        <EditIcon className="w-5 h-5" />
                        {t('profile.picture.change')}
                    </label>
                    {editor.hasPicture && (
                        <button
                            type="button"
                            className="px-6 py-1 rounded-full border-1.6px border-woodyBrown hover:bg-woodyBrown hover:text-white"
                            onClick={editor.remove}
                        >
                            {t('profile.picture.remove')}
                        </button>
                    )}
                </>
            )}
        </div>
    );
};
